import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Modal,
  ModalHeader,
  Button,
  ModalFooter,
  ModalBody,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import check from "../../../assets/icons/estimation_check.svg"
import EstimationFilter from "./filter"
import { Link, useNavigate } from "react-router-dom"
import {
  createRevision,
  deleteEst,
  searchEstimation,
} from "../../../services/estimation/estimation"
import moment from "moment"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import NumberFormat from "../../../utils/numberFormat"
import { capitalize } from "lodash"

const RoughEstimationIndex = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Estimation${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")
  console.log(`desimalrange`, desimalrange)

  const navigate = useNavigate()
  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [customer, setCustomer] = useState("")
  const [location, setLocation] = useState("")
  const [financial, setFinancial] = useState(true)
  const [page, setPage] = useState(1)
  const [datefrom, setDatefrom] = useState()
  const [dateto, setDateto] = useState()
  const [refresh, setRefresh] = useState(0)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  // confirm modal
  const [confirmModal, setConfirmModal] = useState(false)
  // selected id to delete
  const [selectedId, setSelectedId] = useState(null)

  const columns = [
    {
      label: "Estimation Code",
      renderCell: item => {
        return (
          <div
            onClick={() => navigate(`/estimation/quotation-view/${item?.id}`)}
            className="pointer fw-bold"
          >
            <span className="pe-2"> {item?.estimation_code}</span>
            {!item?.estimation_revision?.every(item => item?.status == 0) && (
              <img src={check} className="est-approve-img" />
            )}
          </div>
        )
      },
    },
    {
      label: "Customer Name",
      renderCell: item => {
        const customerName = item?.customers?.customer_name || ""
        const shouldTruncate = customerName.length > 30

        return (
          <div>
            <div id={`uncontroled_${item?.id}`}>
              {shouldTruncate ? (
                <div>{customerName.slice(0, 30)}...</div>
              ) : (
                <div>{customerName}</div>
              )}
            </div>
            {shouldTruncate && (
              <UncontrolledPopover
                target={`uncontroled_${item?.id}`}
                placement="bottom"
                trigger="hover"
              >
                <PopoverBody>
                  <div>{customerName}</div>
                </PopoverBody>
              </UncontrolledPopover>
            )}
          </div>
        )
      },
      // sortKey: "customer_name",
    },
    {
      label: "Project Name",
      renderCell: item => (
        <>
          <div
            className="word-clamp-tbl-est"
            id={`PopoverLegacy-projectName-${item?.id}`}
          >
            {capitalize(item?.project_name)}
          </div>
          {item?.project_name && item?.project_name?.length >= 30 ? (
            <UncontrolledPopover
              placement="bottom"
              target={`PopoverLegacy-projectName-${item?.id}`}
              trigger="hover"
              className="popover-inset"
            >
              <PopoverBody>
                <div className="table-popup-content">
                  {item?.project_name ? item?.project_name : "-"}
                </div>
              </PopoverBody>
            </UncontrolledPopover>
          ) : (
            <></>
          )}
        </>
      ),
      sortKey: "project_name",
    },
    {
      label: "Bid Date",
      renderCell: item => moment(item?.bid_date).format("DD-MMM-YYYY"),
    },
    {
      label: "Updated Date",
      renderCell: item => moment(item?.updated_at).format("DD-MMM-YYYY"),
    },
    {
      label: <div className="text-end pe-5">Amount (AED)</div>,
      renderCell: item => {
        let amount
        if (item?.estimation_revision?.some(item => item?.status == 1)) {
          amount = item?.estimation_revision.find(
            item => item?.status == 1
          )?.amount
        } else {
          amount =
            item?.estimation_revision[item?.estimation_revision?.length - 1]
              ?.amount
        }
        return (
          <div className="text-end pe-5">
            {NumberFormat(Number(amount), desimalrange, desimalrange)}
          </div>
        )
      },
    },

    {
      label: <div className="text-start ps-5">Action</div>,
      renderCell: item => (
        <>
          <div className="text-start ps-5">
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              <>
                {item?.estimation_revision?.every(item => item?.status == 0) ? (
                  // &&item?.estimation_code?.includes(loggedUser?.finance)
                  <>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        navigate(
                          `/estimation/quotation-edit/${item?.estimation_revision?.[
                            item?.estimation_revision?.length - 1
                          ]?.id
                          }`
                        )
                      }
                    >
                      Edit
                    </div>
                    <div
                      className="table-popup-content"
                      // onClick={() =>
                      //   navigate(
                      //     `/estimation-edit/${
                      //       item?.estimation_revision?.[
                      //         item?.estimation_revision?.length - 1
                      //       ]?.id
                      //     }`
                      //   )
                      // }
                      onClick={() => handleCreateRevision(item?.id)}
                    >
                      {`Create New Revision (${item?.estimation_revision?.length})`}
                    </div>
                    <div
                      className="table-popup-content"
                      // onClick={() => handleDeleteEst(item?.id)}
                      onClick={() => {
                        setSelectedId(item?.id)
                        setConfirmModal(true)
                      }}
                    >
                      Delete
                    </div>
                  </>
                ) : item?.project_status == 0 &&
                  !item?.estimation_revision?.every(
                    item => item?.status == 0
                  ) &&
                  (loggedUser?.permission?.some(
                    permissionItem =>
                      permissionItem?.name === "Convert to Project"
                  ) ||
                    loggedUser?.data?.id === 1) ? (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      navigate(
                        `/project-master/add/${item?.estimation_revision
                          .find
                          (item => item?.status == 1)?.id

                        }`
                      )
                    }
                  >
                    Convert to Project
                  </div>
                ) : (
                  <></>
                )}
                <div
                  className={`${item?.status === 1 ? "popover-border" : ""
                    } table-popup-content`}
                  onClick={() =>
                    navigate(`/estimation/quotation-view/${item?.id}`)
                  }
                >
                  View revisions
                </div>
              </>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handleCreateRevision = async id => {
    console.log(`id`, id)
    const responce = await createRevision(id)
    navigate(
      `/estimation/quotation-edit/${responce?.new_estimation_revision_id}`
    )
  }

  const handleDeleteEst = async id => {
    try {
      const responce = await deleteEst(id)
      setRefresh(refresh + 1)
      toastSuccess(responce?.message)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handlePaginate = page => {
    setPage(page)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await searchEstimation({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${customer ? `&client_code=${customer}` : ""}${`&sortOrder=asc`}${location ? `&location_id=${location}` : ""
          }${page ? `&page=${page}` : ""}${datefrom ? `&from_date=${datefrom}` : ""
          }${dateto ? `&to_date=${dateto}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setClassData(response)

      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;

    }
    // ${`&financial=${financial}`}
    if (loggedUser?.data?.id) {
      fetchClass()
    }

  }, [
    status,
    search,
    customer,
    page,
    location,
    loggedUser,
    financial,
    datefrom,
    dateto,
    refresh,
    dataPerPage,
  ])

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleCustomerChange = id => {
    setCustomer(id)
    setPage(1)
  }
  const handleLocationChange = id => {
    setLocation(id)
    setPage(1)
  }
  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  console.log("tableContainerRef", tableContainerRef)

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Estimation"
              breadcrumbObject={[
                { title: "Estimation", link: "/estimation" },
                { title: "Estimations List", link: "#" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "estimation_create"
            ) && (
                <Link
                  to="/estimation/quotation-add"
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                >
                  {"+ Estimation"}
                </Link>
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <EstimationFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCustomerChange={handleCustomerChange}
              handleLocationChange={handleLocationChange}
              handleFinacialChange={handleFinacialChange}
              handleDateChange={handleDateChange}
              sampleUrl={"download/suppliers.xlsx"}
              importUrl={"suppliers/import"}
              isImport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div ref={tableContainerRef} style={{ height: "490px", overflowY: "auto" }}>
                  {classData && (
                    <UpdateTable
                      className="mt-5"
                      nodes={classData?.data?.data}
                      paginate={classData?.data}
                      columns={columns}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      CurrentPage={page}
                      tableWidth="15% 20% 20% 10% 10% 15% 10%"
                      mobileWidth="40% 70% 50% 40% 40% 35% 25%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
          <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)}>
            <ModalHeader toggle={() => setConfirmModal(false)}>
              Delete Quotation Confirmation
            </ModalHeader>
            <ModalBody>
              Are you sure you want to delete this quotation?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => setConfirmModal(false)}>
                No
              </Button>
              <Button
                color="primary"
                onClick={async () => {
                  handleDeleteEst(selectedId)
                  setConfirmModal(false)
                }}
              >
                Yes
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}

export default RoughEstimationIndex
